export default {
    primaryBackground: "#191919",
    secondaryBackground: "#2C3333",
    primary: "white",
    secondary: "black"
}